import LogInDetailsContainer from './log-in-details-container'
import connector from './connector'

export default connector(LogInDetailsContainer)
